/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import type { WatermarkTypeOption } from '../constants'

interface SelectOption {
  value: number | string
  label: string
}

export function transformToSelectOptions(arr: WatermarkTypeOption[]): SelectOption[] {
  if (!Array.isArray(arr)) return []

  return arr.map((val) => {
    // val.value is already translated in getAvailableTypes
    const label = val.value || String(val.id)
    return {
      value: val.id,
      label: label
    }
  })
}

export function formatTextAreaCounter(length: number, max: number, template: string): string {
  const remaining = max - length

  // Check if template has placeholders {0} and {1}
  if (template.includes('{0}') && template.includes('{1}')) {
    return template.replace('{0}', String(remaining)).replace('{1}', String(max))
  }
  // If no placeholders, append the format: "Template: remaining"
  return `${template}: ${remaining}`
}
